<script setup>
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import { copyTextToClipboard } from 'shared/helpers/clipboard';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  id: {
    type: Number,
    default: 0,
  },
  title: {
    type: String,
    default: 'Untitled',
  },
  url: {
    type: String,
    default: '',
  },
  category: {
    type: String,
    default: '',
  },
  locale: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['insert', 'preview']);

const { t } = useI18n();

const handleInsert = e => {
  e.stopPropagation();
  emit('insert', props.id);
};

const handlePreview = e => {
  e.stopPropagation();
  emit('preview', props.id);
};

const handleCopy = async e => {
  e.stopPropagation();
  await copyTextToClipboard(props.url);
  useAlert(t('CONTACT_PANEL.COPY_SUCCESSFUL'));
};
</script>

<template>
  <button
    class="group flex w-full cursor-pointer flex-col gap-1 border-0 bg-auth-surface px-3 py-3 hover:bg-auth-soft focus:bg-auth-soft focus:outline-none dark:bg-auth-surface-dark dark:hover:bg-auth-soft-dark dark:focus:bg-auth-soft-dark"
    @click="handlePreview"
  >
    <h4
      class="mb-0 w-full text-sm font-medium text-auth-text group-hover:text-auth-action dark:text-auth-text-dark dark:group-hover:text-auth-accent ltr:text-left rtl:text-right"
    >
      {{ title }}
    </h4>

    <div class="flex w-full content-between items-center gap-1">
      <p
        class="mb-0 w-full text-sm text-auth-muted dark:text-auth-muted-dark ltr:text-left rtl:text-right"
      >
        {{ locale }}
        {{ ` / ` }}
        {{ category || $t('HELP_CENTER.ARTICLE_SEARCH_RESULT.UNCATEGORIZED') }}
      </p>
      <div class="flex gap-0.5">
        <Button
          :title="$t('HELP_CENTER.ARTICLE_SEARCH_RESULT.COPY_LINK')"
          faded
          slate
          xs
          type="reset"
          icon="i-lucide-copy"
          class="invisible !rounded-lg !border-auth-border !bg-auth-surface !text-auth-muted group-hover:visible hover:!bg-auth-border hover:!text-auth-text dark:!border-auth-border-dark dark:!bg-auth-surface-dark dark:!text-auth-muted-dark dark:hover:!bg-auth-border-dark dark:hover:!text-auth-text-dark"
          @click="handleCopy"
        />
        <Button
          xs
          faded
          slate
          :label="$t('HELP_CENTER.ARTICLE_SEARCH_RESULT.INSERT_ARTICLE')"
          class="!rounded-lg !border-auth-border !bg-auth-soft !text-auth-text hover:!bg-auth-border dark:!border-auth-border-dark dark:!bg-auth-soft-dark dark:!text-auth-text-dark dark:hover:!bg-auth-border-dark"
          @click="handleInsert"
        />
      </div>
    </div>
  </button>
</template>
